import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faSave } from '@fortawesome/free-solid-svg-icons';

//Components
import TextField from '../../../../components/TextField/TextField';
import TabelaContratos from './TabelaContratos';

//Api
import volumetria_api from '../../../../api/volumetria_api';
import gerador_api from '../../../../api/gerador_api';
import transportador_api from '../../../../api/transportador_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos, PrintValidate, objCampo } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../../context/auth';
import { useCallback } from 'react';

//Estado inicial do contrato
function initialStateContrato() {
    return {
        id: "",
        tbGeradores_Id: "",
        tbTransportadores_Id: "",
        tbTipoColeta_Id: "",
        tbMotivosPendenciaContratoGerador_Id: null,
        tbPGRSGerador_Id: null,
        modalidade: "",
        frequencia: "",
        calendario: "",
        situacaoContrato: "",
        quantidadeContratada: "0,00",
        tbGeradorLocalidade_id: "",
        tbVolumetria_ID: "",
        unidadeMedida: "",
        inicioVigencia: "",
        terminoVigencia: "",
        numeroContrato: "",
        anexo: "",
        dataCadastro: "",
        usuarioAtualizacao: "",
        dataAtualizacao: "",
        editContrato: "",
        calendarioList: ""
    }
}

export default function Contratos({ gerador, setGerador, openForm, setOpenForm = () => { }, integracaoCadastros, pgrs = false }) {
    const { session, setLoading, setupVariavel } = useAuth();

    //Estado de controle dos campos do contrato
    const [contrato, setContrato] = useState(initialStateContrato());

    //Estado de controle das localidades
    //CE-4307: endereço Inativo fica fora da lista de contratos
    const [localidadesPGRS, setLocalidadesPGRS] = useState(gerador.localidades.filter(l => l.status !== "Inativo"));

    //Estado de controle das opções de unidades de medidas
    const [optionsUnidadeDeMedida, setOptionsUnidadeDeMedida] = useState([]);

    //Opções do campo de calendario
    const [optionsCalendario, setOptionsCalendario] = useState([]);

    const [optionsMotivoContratoPendentes, setOptionsMotivoContratoPendentes] = useState([]);

    //Estado para validação de erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Estado de controle das opções de transportadores
    const [optionsTransportadores, setOptionsTransportadores] = useState([]);

    const [modalidadePGRSObrigatoria, setModalidadePGRSObrigatoria] = useState(false);

    //Campos para validação de erros
    const [campos, setCampos] = useState([
        { ...objCampo({ name: "frequencia", required: true }) },
        { ...objCampo({ name: "numeroContrato", required: true, number: true }) },
        { ...objCampo({ name: "tbVolumetria_ID", required: true }) },
        { ...objCampo({ name: "quantidadeContratada", required: true, number: true }) },
        ...pgrs == false ? [
            { ...objCampo({ name: "situacaoContrato", required: true }) },
            { ...objCampo({ name: "inicioVigencia", required: true }) },
            { ...objCampo({ name: "terminoVigencia", required: true }) },
        ] : [
            { ...objCampo({ name: "tbTransportadores_Id", required: true }) }
        ],
    ]);

    //Estado de controle do status do contrato
    const optionsSituacao = [
        { value: "Ativo", text: "Ativo" },
        { value: "Sem Contrato", text: "Sem Contrato" },
        { value: "Pendente", text: "Pendente" }
    ]

    //Estado de controle das opções de frequencia do contrato
    const optionsFrequencia = [
        { value: "", text: "Selecione" },
        { value: "Diario", text: "Diario" },
        { value: "Semanal", text: "Semanal" },
        { value: "Mensal", text: "Mensal" },
        { value: "On demand", text: "On demand" },
    ]

    //Carrega os dados do contrato no formulario
    const loadContrato = (_contrato) => {
        volumetria_api.GetListByModalidade(_contrato.tbTipoColeta_Id).then(response => {
            if (!_contrato.id && pgrs == false) {
                _contrato.id = 0;
                _contrato.situacaoContrato = "Ativo";
            }

            if (pgrs == true) {
                _contrato.tipoColeta = _contrato.modalidade;
                _contrato.situacaoContrato = "Pendente";
            }

            if (_contrato.inicioVigencia) {
                const _inicioVigencia = _contrato.inicioVigencia.split('/');
                _contrato.inicioVigencia = `${_inicioVigencia[1]}/${_inicioVigencia[0]}/${_inicioVigencia[2]}`;
                _contrato.inicioVigencia = moment(_contrato.inicioVigencia).format("YYYY-MM-DD");
            }

            if (_contrato.terminoVigencia) {
                const _terminoVigencia = _contrato.terminoVigencia.split('/');
                _contrato.terminoVigencia = `${_terminoVigencia[1]}/${_terminoVigencia[0]}/${_terminoVigencia[2]}`;
                _contrato.terminoVigencia = moment(_contrato.terminoVigencia).format("YYYY-MM-DD");
            }

            if (!_contrato.quantidadeContratada) {
                _contrato.quantidadeContratada = "0,00";
            }
            _contrato.localidade = `${gerador.localidades[_contrato.tableData.mainId].cep}, ${gerador.localidades[_contrato.tableData.mainId].cidade} - ${gerador.localidades[_contrato.tableData.mainId].uf} ,${gerador.localidades[_contrato.tableData.mainId].bairro}, ${gerador.localidades[_contrato.tableData.mainId].logradouro}, ${gerador.localidades[_contrato.tableData.mainId].numero} ${gerador.localidades[_contrato.tableData.mainId].complemento ? ", - " + gerador.localidades[_contrato.tableData.mainId].complemento : ""}`;

            const opVolumetrias = [{ text: "Selecione", value: "" }, ...response.data.map(value => {
                return { text: value.tbVolumetria_Descricao, value: value.id.toString() }
            })];

            if (_contrato.frequencia == "On demand" || _contrato.frequencia == "Diario") {
                _contrato.calendarioList = [];
            } else {
                _contrato.calendarioList = _contrato.calendario
                    ?
                    _contrato.calendario.split("|").map(value => {
                        return { value: value, label: value };
                    }).filter(x => x.value !== "")
                    : []

            }

            Object.keys(_contrato).map(key => {
                if (_contrato[key] != null && _contrato[key] != 0 && typeof _contrato[key] != "object") {
                    _contrato[key] = _contrato[key].toString();
                } else if (typeof _contrato[key] != "object") {
                    _contrato[key] = "";
                }
            });

            loadCalendario(_contrato.frequencia);
            setContrato(_contrato);

            if (_contrato.situacaoContrato == "Pendente" && optionsMotivoContratoPendentes.length > 0 && pgrs == false) {
                setCampos((prev) => ([...prev, { ...objCampo({ name: "tbMotivosPendenciaContratoGerador_Id", required: true }) }]));
                _contrato.tbMotivosPendenciaContratoGerador_Id = _contrato.tbMotivosPendenciaContratoGerador_Id ? _contrato.tbMotivosPendenciaContratoGerador_Id.toString() : "";
            }

            setOptionsUnidadeDeMedida([...opVolumetrias]);
            setOpenForm(true);

        }).catch(e => {
            showMessage("Aviso", e.message, "error");
        })
    }

    //Função de clique do botão de editar contrato ou adicionar contrato
    const onClickAdicionarEditar = (rowData) => {
        if (rowData.pgrsObrigatorio && rowData.tbPGRSGerador_Id && session?.acesso?.sigla !== "GG") {
            setLoading(false)
            gerador_api.GetPermissaoAlteracaoPGRSGerador(rowData.tbPGRSGerador_Id)
                .then(response => {
                    if (!response.data) {
                        showMessage("Aviso!", "O status do contrato não pode ser alterado, pois o PGRS não está aprovado.", "warning", null)
                    } else {
                        setModalidadePGRSObrigatoria(rowData.pgrsObrigatorio)
                        loadContrato(rowData);
                    }
                })
                .catch(err => showMessage("Error", err.message, "error", null))
                .finally(() => setLoading(false));
        } else {
            setModalidadePGRSObrigatoria(rowData.pgrsObrigatorio)
            loadContrato(rowData);
        }
    }

    const formatarDadosParaBackend = () => {
        // Formata as localidades
        const localidadesFormatadas = gerador.localidades?.map(l => ({
            ...l,
            contratos: l.contratos?.map(c => ({
                id: c.id || 0,
                editContrato: c.editContrato || false,
                tbGeradorLocalidade_id: c.tbGeradorLocalidade_id || 0,
                tbGeradores_Id: c.tbGeradores_Id || 0,
                tbTipoColeta_Id: c.tbTipoColeta_Id || 0,
                usuarioAtualizacao: c.usuarioAtualizacao || 0,
                situacaoContrato: c.situacaoContrato || "",
                quantidadeContratada: c.quantidadeContratada ? c.quantidadeContratada.toString().replace(",", ".") : 0,
            })),
        }));

        // Formata o gerador
        const geradorFormatado = {
            ...gerador,
            id: gerador.id || 0,
            tbPrefeituras_id: gerador.tbPrefeituras_id || 0,
            tbSegmentos_Id: gerador.tbSegmentos_Id || 0,
            tbSetores_Id: gerador.tbSetores_Id || 0,
            tbSetores_id: gerador.tbSetores_id || 0,
            localidades: localidadesFormatadas,
        };

        // Formata o contrato
        const contratoFormatado = {
            ...contrato,
            id: contrato.id || 0,
            editContrato: contrato.editContrato || false,
            tbGeradorLocalidade_id: contrato.tbGeradorLocalidade_id || 0,
            tbGeradores_Id: contrato.tbGeradores_Id || 0,
            tbTipoColeta_Id: contrato.tbTipoColeta_Id || 0,
            usuarioAtualizacao: contrato.usuarioAtualizacao || 0,
            situacaoContrato: contrato.situacaoContrato || "",
            quantidadeContratada: contrato.quantidadeContratada ? contrato.quantidadeContratada.toString().replace(",", ".") : 0,
        };

        return {
            Gerador: geradorFormatado,
            Contrato: contratoFormatado,
        };
    };

    //Função para adicionar um novo contrato
    const addNovoContrato = async () => {
        const _gerador = { ...gerador }
        const _contrato = { ...contrato }

        // Formata os dados para o backend
        const model = formatarDadosParaBackend();

        let _campos = [...campos];

        if ((contrato.frequencia === 'Semanal' || contrato.frequencia === 'Mensal') &&
            contrato.calendarioList.length === 0) {
            var avisoFrequencia = 'Quando o tipo de Frequência é do tipo ' + contrato.frequencia +
                ' é obrigatório adicionar pelo menos um item no campo Calendário.';
            showMessage("Aviso!", avisoFrequencia, "warning", null)
            return;
        }

        if (pgrs)
            _campos = _campos.filter(x => x.name != "tbMotivosPendenciaContratoGerador_Id" || x.name != "tbPGRSGerador_Id")

        if (_contrato?.situacaoContrato != "Sem Contrato" && _contrato?.situacaoContrato != "Pendente") {
            if (Object.keys(errors).length > 0)
                return;
            const _errors = validarCampos(_contrato, _campos);
            setErrors(_errors[0]);
            if (_errors[1].length > 0)
                return;
        }

        let permitirCadastroContrato = { sucesso: false, mensagem: "" };
        let falhouRequisicao = false;
        await gerador_api.PostAnalisePermissaoCadastroContrato(model, pgrs ? true : false)
            .then(response => {
                permitirCadastroContrato.sucesso = response.data.sucesso;
                permitirCadastroContrato.mensagem = response.data.mensagem;
            })
            .catch(err => {
                falhouRequisicao = true;
                showMessage("Error", err.message, "error", null);
            })
            .finally(() => setLoading(false));

        if (falhouRequisicao)
            return;

        if (!permitirCadastroContrato.sucesso) {
            showMessage("Aviso!", permitirCadastroContrato.mensagem, "warning", null)
            return;
        }

        if (pgrs == true) {
            let transportador = optionsTransportadores.filter(x => x.value == _contrato.tbTransportadores_Id)[0]
            _contrato.volumetria = _contrato.unidadeMedida;
            _contrato.nomeFantasiaTransportador = transportador.label;
            _contrato.editContrato = true;
            _contrato.contratoPendentePGRS = true;
            _contrato.pgrsObrigatorio = modalidadePGRSObrigatoria == true ? "Sim" : "Não"
        }

        if (_contrato.id == 0 && _contrato.situacaoContrato !== "Ativo" && pgrs == false) {
            showMessage("Aviso", "Não é permitido adicionar um contrato com a situação Sem Contrato", "info");
            return;
        }

        // tableData.mainId = Index da Localidade no array
        // tableData.secondId = Index do Contrato no array
        _gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId] = { ..._contrato };

        if (_contrato.calendarioList.length > 0) {
            _gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId].calendario = _contrato.calendarioList.map(value => value.label).toString().replaceAll(",", "|") + "|";
        }

        if (!_gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId].id) {
            _gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId].id = 0;
        }

        if (_gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId].situacaoContrato === "Ativo" && !_gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId].id) {
            _gerador.localidades[_contrato.tableData.mainId].contratos[_contrato.tableData.secondId].editContrato = true;
        }

        setGerador(_gerador);
        setOpenForm(false);
        setContrato(initialStateContrato());
        setModalidadePGRSObrigatoria(false)
    }

    //Change dos campos do formulario
    const onChangeContrato = (e) => {
        const { name, value } = e.target;
        const _contrato = {
            ...contrato,
            [name]: value
        }

        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_contrato, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        if (name == "situacaoContrato" && value == "Sem Contrato") {
            setErrors({});
        }

        if (name == "situacaoContrato" && value == "Pendente" && optionsMotivoContratoPendentes.length > 0 && !pgrs) {
            setCampos([...campos.filter(x => x.name != "tbMotivosPendenciaContratoGerador_Id"), { ...objCampo({ name: "tbMotivosPendenciaContratoGerador_Id", required: true }) }]);
        } else if (name == "situacaoContrato" && value != "Pendente" && !pgrs) {
            setCampos([...campos.filter(x => x.name != "tbMotivosPendenciaContratoGerador_Id")])
            _contrato.tbMotivosPendenciaContratoGerador_Id = "";
        }

        setContrato(_contrato);
    }

    //Change do campo de unidade de medida
    const onChangeUnidadeMedida = (e) => {
        const { name, value } = e.target;
        const _contrato = {
            ...contrato,
            [name]: value,
            unidadeMedida: optionsUnidadeDeMedida.filter(u => u.value === value)[0].text
        }
        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_contrato, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setContrato(_contrato);
    }

    //Change para o campo de frequencia
    const onChangeFrequencia = (e) => {
        const { name, value } = e.target;
        const _contrato = {
            ...contrato,
            [name]: value
        }

        _contrato.calendario = "";
        _contrato.calendarioList = [];

        loadCalendario(_contrato.frequencia);

        const _campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_contrato, _campo);

        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setContrato(_contrato);
    }

    const updateCampoCalendario = (required) => {
        setCampos((prev) =>
            prev.map((campo) =>
                campo.name === "calendarioList" ? { ...campo, required } : campo
            )
        );
    };

    //Carrega os dados do calendario
    const loadCalendario = (frequencia) => {
        if (frequencia === "Semanal") {
            const _semana = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
            const _calendario = _semana.map(value => {
                return { label: value, value: value };
            })

            updateCampoCalendario(true);
            setOptionsCalendario(_calendario);
        } else if (frequencia === "Mensal") {
            const _dias = [];
            for (let i = 1; i <= 31; i++) {
                _dias.push(i);
            }
            const _calendario = _dias.map(key => {
                return { label: key, value: key }
            });

            updateCampoCalendario(true);
            setOptionsCalendario(_calendario);
        } else {
            updateCampoCalendario(false);
            setOptionsCalendario([]);
        }
    }

    //Change para o campo de calendario
    const onChangeCalendario = (e, select) => {
        const { name } = select;
        const _contrato = {
            ...contrato,
            [name]: e
        }
        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_contrato, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setContrato(_contrato);
    }

    //Change para o campo terminoVigencia
    const onChangeTerminoVigencia = (e) => {
        const { name, value } = e.target;
        const _contrato = {
            ...contrato,
            [name]: value
        }
        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_contrato, campo);
        const inicioVigencia = new Date(contrato.inicioVigencia);
        const terminoVigencia = new Date(value);
        if (inicioVigencia.getTime() >= terminoVigencia.getTime()) {
            _errors[0].terminoVigencia = {};
            _errors[0].terminoVigencia.message = "Data inválida";
            _errors[1].push(_errors[0].terminoVigencia)
        }
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setContrato(_contrato);
    }

    //Ações da tabela de contratos para selecionar um contrato
    const actionsExpandable = [

        (rowData) => {
            //Controle dos contratos que podem ser editados
            if (rowData.editContrato) {
                return actionsTable.editar(onClickAdicionarEditar);
            } else {
                return null;
            }
        },
        (rowData) => {
            //Controle dos contratos que podem ser editados
            if (rowData.id === 0 &&
                rowData.situacaoContrato === "Sem Contrato" &&
                !integracaoCadastros &&
                (
                    (rowData.pgrsObrigatorio == false) ||
                    (session.acesso.sigla == "TR" && setupVariavel?.quemCadastraGeradores != "Gerador") ||
                    ((session.acesso.sigla == "GG" && (setupVariavel?.quemCadastraContrato == "Gerador" || setupVariavel?.quemCadastraContrato == "Transportador/Gerador")) || session.acesso.sigla == "GS")
                )
            ) {
                return actionsTable.adicionar(onClickAdicionarEditar);
            } else {
                return null;
            }
        }
    ]

    const onChangeAnexo = (e) => {
        if (!e.target.files || !e.target.files[0]) {
            setContrato({
                ...contrato,
                anexo: ""
            });
            return;
        }

        if (!e.target.files[0].type.startsWith("application/pdf")) {
            showMessage(
                "Aviso",
                "Apenas arquivos no formato PDF é permitido. Por favor, selecione um arquivo válido.",
                "warning",
                null
            );
            return;
        }

        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            let base64 = evt.target.result.split(",")[1];
            setContrato({
                ...contrato,
                anexo: base64,
            });
        });

        FR.readAsDataURL(e.target.files[0]);
    };

    //Função de onchange do campo de tbTipoColeta_Id
    const onChangeMotivoContrato = (e, select) => {
        const { name } = select;
        const _contrato = { ...contrato, tbMotivosPendenciaContratoGerador_Id: e ? e.value.toString() : "" };

        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_contrato, campo);

        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setContrato(_contrato);
    }

    const abrirPDF = (anexo) => {
        // Cria um blob a partir do base64
        const byteCharacters = atob(anexo);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Cria uma URL temporária para o blob e a abre em uma nova aba
        const url = URL.createObjectURL(blob);
        window.open(url);

        // Limpa a URL temporária após abrir o PDF
        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 100);
    };

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setContrato({
            ...contrato,
            [name]: e ? e.value.toString() : null
        });
    }

    const loadMotivosContratoPendente = useCallback(() => {
        setLoading(true);
        gerador_api.GetListMotivosContratoPendente()
            .then(response => {
                const formattedData = response.data.map(value => ({
                    ...value,
                    label: value.motivo,
                    value: value.id,
                }));

                setOptionsMotivoContratoPendentes(formattedData);
            })
            .catch(err => showMessage("Error", err.message, "error", null))
            .finally(() => setLoading(false));
    }, []);

    const loadTransportadores = useCallback(() => {
        transportador_api.GetList(null, "Ativo")
            .then(response => {
                const formattedData = response.data.map(value => ({
                    value: value.id,
                    label: value.fantasia
                }));
                setOptionsTransportadores(formattedData);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        loadMotivosContratoPendente();
        loadContratos();

        if (pgrs)
            loadTransportadores()
    }, []);

    const loadContratos = () => {
        // Retornar somente localidades vinculadas a PGRS
        //CE-4307: endereço Inativo não exibe contratos/modalidades
        const localidadesVisiveis = gerador.localidades.filter(l => l.status !== "Inativo");

        let _localidades = localidadesVisiveis.filter(l =>
            l.contratos.some(c => pgrs && c.tbPGRSGerador_Id != null)
        );

        // Se não houverem localidades vinculadas a PGRS, retorna todas as localidades
        if (_localidades.length === 0) {
            _localidades = localidadesVisiveis;
        }

        setLocalidadesPGRS(_localidades)
    }

    return (
        <div className={`${!pgrs ? 'm-4 p-2' : ''} containerStep rounded-3`}>
            <div className={`mb-4 formContainer ${openForm ? "" : "close"}`}>
                <Row className='mb-4'>
                    {pgrs && <Col md="12" lg="12">
                        <TextField
                            name="tbTransportadores_Id"
                            label={"Transportador"}
                            type={"select"}
                            searchable
                            value={optionsTransportadores.filter(x => x.value == contrato.tbTransportadores_Id)[0]}
                            invalid={!!errors.tbTransportadores_Id}
                            onChange={onChangeSelected}
                            options={optionsTransportadores} />
                    </Col>
                    }
                    <Col md="12" lg="12">
                        <TextField
                            disabled={true}
                            label={"* Endereço"}
                            value={contrato.localidade}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            disabled={true}
                            label={"* Modalidade de coleta"}
                            value={contrato.modalidade}
                        />
                    </Col>
                    {!pgrs &&
                        <>
                            <Col md="12" lg={contrato.situacaoContrato == "Pendente" && optionsMotivoContratoPendentes.length > 0 && !pgrs ? 2 : 4}>
                                <TextField
                                    maxLength={"30"}
                                    invalid={errors.situacaoContrato ? true : false}
                                    name={"situacaoContrato"}
                                    onChange={onChangeContrato}
                                    label={"* Situação"}
                                    type={"select"}
                                    options={optionsSituacao}
                                    value={contrato.situacaoContrato}
                                />
                                <PrintValidate errors={errors} field={"situacaoContrato"} />
                            </Col>
                            {contrato.situacaoContrato == "Pendente" && optionsMotivoContratoPendentes.length > 0 &&
                                <Col md="12" lg="4">
                                    <TextField
                                        name={"tbMotivosPendenciaContratoGerador_Id"}
                                        label={"* Motivo Contrato Pendente"}
                                        type={"select"}
                                        searchable
                                        placeholder='Selecione o motivo'
                                        value={optionsMotivoContratoPendentes?.filter(x => x.value == contrato.tbMotivosPendenciaContratoGerador_Id)[0]}
                                        options={optionsMotivoContratoPendentes}
                                        onChange={onChangeMotivoContrato}
                                        invalid={errors.tbMotivosPendenciaContratoGerador_Id}
                                    />
                                    <PrintValidate errors={errors} field={"situacaoContrato"} />
                                </Col>
                            }
                        </>
                    }

                    <Col md="12" lg={contrato.situacaoContrato == "Pendente" && optionsMotivoContratoPendentes.length > 0 && !pgrs ? 2 : 4}>
                        <TextField
                            maxLength={"20"}
                            invalid={errors.frequencia ? true : false}
                            name={"frequencia"}
                            disabled={modalidadePGRSObrigatoria && (!pgrs || (pgrs && session?.acesso?.sigla !== "GG"))}
                            onChange={onChangeFrequencia}
                            label={"* Frequência"}
                            type={"select"}
                            options={optionsFrequencia}
                            value={contrato.frequencia}
                        />
                        <PrintValidate errors={errors} field={"frequencia"} />
                    </Col>
                    {optionsCalendario.length > 0
                        ?
                        <Col md="12" lg="12">
                            <TextField
                                maxLength={"100"}
                                multiple
                                disabled={modalidadePGRSObrigatoria && (!pgrs || (pgrs && session?.acesso?.sigla !== "GG"))}
                                invalid={errors.calendarioList ? true : false}
                                name={"calendarioList"}
                                onChange={onChangeCalendario}
                                label={"* Calendário"}
                                type={"select"}
                                options={optionsCalendario}
                                value={contrato.calendarioList}
                            />
                            <PrintValidate errors={errors} field={"calendarioList"} />
                        </Col>
                        :
                        <></>}
                    <Col md="12" lg="4">
                        <TextField
                            maxLength={"10"}
                            mask={mascaras.numeroMask}
                            disabled={modalidadePGRSObrigatoria && (!pgrs || (pgrs && session?.acesso?.sigla !== "GG"))}
                            invalid={errors.numeroContrato ? true : false}
                            name={"numeroContrato"}
                            onChange={onChangeContrato}
                            label={"* Número Contrato"}
                            value={contrato.numeroContrato}
                        />
                        <PrintValidate
                            errors={errors}
                            field={"numeroContrato"}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            invalid={errors.tbVolumetria_ID ? true : false}
                            name={"tbVolumetria_ID"}
                            disabled={modalidadePGRSObrigatoria && (!pgrs || (pgrs && session?.acesso?.sigla !== "GG"))}
                            onChange={onChangeUnidadeMedida}
                            label={"* Unidade de medida"}
                            type={"select"}
                            value={contrato.tbVolumetria_ID}
                            options={optionsUnidadeDeMedida}
                        />
                        <PrintValidate errors={errors} field={"tbVolumetria_ID"} />
                    </Col>
                    <Col md="12" lg={!pgrs ? "4" : "5"}>
                        <TextField
                            invalid={errors.quantidadeContratada ? true : false} mask={mascaras.floatMask}
                            name={"quantidadeContratada"}
                            disabled={modalidadePGRSObrigatoria && (!pgrs || (pgrs && session?.acesso?.sigla !== "GG"))}
                            onChange={onChangeContrato}
                            label={"* Quantidade Contratada (Unidade por coleta)"}
                            value={contrato.quantidadeContratada}
                        />
                        <PrintValidate errors={errors} field={"quantidadeContratada"} />
                    </Col>
                    {!pgrs &&
                        <>
                            <Col md="12" lg={"3"}>
                                <TextField
                                    invalid={errors.inicioVigencia ? true : false}
                                    name={"inicioVigencia"}
                                    onChange={onChangeContrato}
                                    label={"* Início vigência"}
                                    type={"date"} value={contrato.inicioVigencia}
                                />
                                <PrintValidate errors={errors} field={"inicioVigencia"} />
                            </Col>
                            <Col md="12" lg={"3"}>
                                <TextField
                                    className={"margin"}
                                    invalid={errors.terminoVigencia ? true : false}
                                    name={"terminoVigencia"}
                                    onChange={onChangeTerminoVigencia}
                                    label={"* Final vigência"}
                                    type={"date"}
                                    value={contrato.terminoVigencia}
                                />
                                <PrintValidate errors={errors} field={"terminoVigencia"} />
                            </Col>
                        </>
                    }
                    {session.acesso.sigla == "TR" &&
                        <Col md="12" lg={contrato.anexo ? "5" : "6"}>
                            <TextField
                                label={"Anexo"}
                                type={"file"}
                                onChange={onChangeAnexo}
                                name="anexo"
                                accept="application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                disabled={setupVariavel?.quemCadastraContrato == "Gerador" && session?.acesso?.sigla !== "GG"}
                            />
                        </Col>
                    }

                    {contrato?.anexo && contrato?.anexo?.includes(".pdf") && (
                        <Col md={"12"} lg={"1"} className="text-center" style={{ cursor: "pointer" }} onClick={() => window.open(contrato?.anexo, "_blank")}>
                            <br />
                            <FontAwesomeIcon icon={faFilePdf} color='red' size="3x" className='mt-1' />
                        </Col>
                    )}

                    {contrato?.anexo && !contrato?.anexo?.includes(".pdf") && (
                        <Col md={"12"} lg={"1"} className="text-center" style={{ cursor: "pointer" }} onClick={() => window.open(abrirPDF(contrato?.anexo), "_blank")}>
                            <br />
                            <FontAwesomeIcon icon={faFilePdf} color='red' size="3x" className='mt-1' />
                        </Col>
                    )}
                </Row>
                <div className='d-flex align-items-center justify-content-center'>
                    <Button
                        color='success'
                        className='bg-gradient'
                        onClick={addNovoContrato}>
                        <FontAwesomeIcon icon={faSave} /> Salvar
                    </Button>
                    <Button
                        className=' ms-4 bg-gradient'
                        onClick={() => setOpenForm(false)}> Cancelar
                    </Button>
                </div>
            </div>

            <TabelaContratos items={localidadesPGRS} actionsExpandable={actionsExpandable} />
        </div>
    )
}